import { render, staticRenderFns } from "./TippUpDownArrow.vue?vue&type=template&id=4ecad92c&scoped=true&"
import script from "./TippUpDownArrow.vue?vue&type=script&lang=js&"
export * from "./TippUpDownArrow.vue?vue&type=script&lang=js&"
import style0 from "./TippUpDownArrow.vue?vue&type=style&index=0&id=4ecad92c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecad92c",
  null
  
)

export default component.exports